import { t } from '@lingui/macro'
import { StyleSheet, Text, View } from '@react-pdf/renderer'
import {
  defaultFormPdfFontFamily,
  inuktitutFormPdfFontFamily
} from 'app/views/forms/pdf-components/FormPdf'
import { pdfTableStyles } from 'app/views/forms/pdf-components/PDFCommon'
import { myI18n } from 'translation/I18nConnectedProvider'
import { objectiveTranslations } from './FormObjectives'

export const FormObjectivesFillablePdf = ({
  value,
  elementType,
  typeProps,
  langVersion,
  title,
  helpText,
  tooltip,
  connectedObject,
  altLabelPlacement,
  ...props
}) => {
  const { options = [] } = typeProps
  const needsHelpText = typeProps?.needsHelpText?.[langVersion]
  const outcomesHelpText = typeProps?.outcomesHelpText?.[langVersion]
  // const fundType = connectedObject
  //   ? connectedObject.RecordType.Id
  //   : STF_LP_RECORD_TYPE

  const fontFamily =
    langVersion === 'iu-cans'
      ? inuktitutFormPdfFontFamily
      : defaultFormPdfFontFamily
  const styles = {
    ...pdfTableStyles,
    ...StyleSheet.create({
      headerCell: {
        ...pdfTableStyles.tableCol,
        ...pdfTableStyles.tableCell,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'left',
        flex: 1,
        fontFamily,
        fontWeight: 'bold'
      },
      cell: {
        ...pdfTableStyles.tableCol,
        ...pdfTableStyles.tableCell,
        flex: 1,
        fontFamily,
        minHeight: 35
      },
      tableRow: {
        ...pdfTableStyles.tableRow,
        flexWrap: 'nowrap',
        display: 'flex',
        width: '100%'
      }
    })
  }

  return (
    <View style={pdfTableStyles.table}>
      <View style={styles.tableRow}>
        <View style={styles.headerCell}>
          <Text>{myI18n?._(t`Objective`)}</Text>
        </View>
        <View style={{ ...styles.headerCell, flex: 2 }}>
          <Text>{myI18n?._(t`Needs`)}</Text>
          {needsHelpText && (
            <Text style={{ fontWeight: 'light', fontStyle: 'italic' }}>
              {needsHelpText}
            </Text>
          )}
        </View>
        <View style={{ ...styles.headerCell, flex: 2 }}>
          <Text>{myI18n?._(t`Outcomes`)}</Text>
          {outcomesHelpText && (
            <Text style={{ fontWeight: 'light', fontStyle: 'italic' }}>
              {outcomesHelpText}
            </Text>
          )}
        </View>
      </View>
      {options?.map((data, index) => {
        const { labels, value } = data
        const objectiveTranslationMsg = objectiveTranslations[value] || ''

        return (
          <View style={styles.tableRow} key={index}>
            <View style={styles.cell}>
              <Text>
                {labels?.[langVersion] ? labels[langVersion] : myI18n._(objectiveTranslationMsg)}
              </Text>
            </View>
            <View style={{ ...styles.cell, flex: 2 }} />
            <View style={{ ...styles.cell, flex: 2 }} />
          </View>
        )
      })}
    </View>
  )
}
